/**
 * Le module `express` vu par server.js : un routeur minimal. En CommonJS,
 * parce que server.js appelle directement le module : express(). Les routes de
 * l'API ne sont pas servies sur le réseau mais appelées directement par
 * l'interface, via traiter() (voir src/main.js).
 */
const routeurs = [];

function compiler(motif) {
  const noms = [];
  const regex = new RegExp(`^${motif.replace(/:(\w+)/g, (_, nom) => { noms.push(nom); return '([^/]+)'; })}$`);
  return { regex, noms };
}

function express() {
  const routes = [];
  const app = {
    use() {},
    listen() {},
    routes
  };
  for (const methode of ['get', 'post', 'patch', 'delete', 'put']) {
    // Les intermédiaires (lecture du JSON…) n'ont pas lieu d'être ici : le
    // corps arrive déjà décodé. Seul le dernier gestionnaire compte.
    app[methode] = (motif, ...gestionnaires) => {
      routes.push({ methode: methode.toUpperCase(), ...compiler(motif), gestionnaire: gestionnaires[gestionnaires.length - 1] });
    };
  }
  routeurs.push(app);
  return app;
}
express.json = () => () => {};
express.static = () => () => {};

module.exports = express;
module.exports.traiter = traiter;

/**
 * Exécute la route correspondant à la requête et renvoie une Response, ou
 * null si aucune route ne correspond.
 */
async function traiter(methode, url, corps) {
  const { pathname, searchParams } = new URL(url, location.href);
  for (const app of routeurs) {
    for (const route of app.routes) {
      if (route.methode !== methode) continue;
      const m = pathname.match(route.regex);
      if (!m) continue;
      const params = Object.fromEntries(route.noms.map((nom, i) => [nom, decodeURIComponent(m[i + 1])]));
      return executer(route.gestionnaire, {
        method: methode,
        params,
        query: Object.fromEntries(searchParams),
        body: corps
      });
    }
  }
  return null;
}

function executer(gestionnaire, req) {
  return new Promise((ok, ko) => {
    let statut = 200;
    const entetes = new Headers();
    const res = {
      status(code) { statut = code; return res; },
      set(nom, valeur) { entetes.set(nom, valeur); return res; },
      json(objet) {
        entetes.set('Content-Type', 'application/json; charset=utf-8');
        return res.send(JSON.stringify(objet));
      },
      send(contenu) {
        ok(new Response(statut === 204 ? null : contenu, { status: statut, headers: entetes }));
        return res;
      },
      end() { return res.send(null); }
    };
    try {
      Promise.resolve(gestionnaire(req, res)).catch(ko);
    } catch (err) {
      ko(err);
    }
  });
}
